import React from "react";
import { getFatafatResultsDetailData } from "../../util";
import "./css/style.min.css";
import "./css/matkaplay.css";
import "../common.css";

const FatafatDetailScreen = ({ data, fatafatTableList }) => {
  const fatataResultTimings = data?.fatafat_result_timings ?? [];
  return (
    <>
      <div className="round_border_card">
        <h2 className="white-header">Shanti Fatafat Time Chart </h2>
        <div className="panel-detail">
          <table>
            <tbody>
              <tr>
                <th>Date</th>
                {fatataResultTimings.map((timeVal, index) => {
                  return <th key={`${timeVal}_${index}`}>{timeVal}</th>;
                })}
              </tr>
              {getFatafatResultsDetailData(fatafatTableList, fatataResultTimings.length).map((item, index) => {
                
                return (
                  <tr key={`tibletable-${index}`}>
                    <td>{item.date.split("T")[0]}  <br />  <br /> </td>
                    <>
                      {item.dateWiseData.map((day, innerIndex) => {
                        return (
                          <td key={`${day}_${index}_${innerIndex}`}>
                            <div className="panel-detail-td">
                              <span>{day.guessNumber}</span>
                              <br />
                              <span className="font-weight-bold">{day.winnerValue}</span>
                            </div>
                          </td>
                        );
                      })}
                    </>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default FatafatDetailScreen;
